import React, { lazy } from 'react';
import { FadeInUp } from './FadeInUp';
const painPoints = [{
  image: 'https://cdn.magicpatterns.com/uploads/cbwTZQjChTR2C1uoFoD5RC/ladrido_v2.jpg',
  title: 'Ladridos excesivos por ruidos',
  description: 'El estrés de no poder descansar por cada ruido del pasillo.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/iJZM6JtNCxeJJryboBqb7Z/destrozo_v2.jpg',
  title: 'Destrozos cuando te vas',
  description: 'Llegar a casa con el miedo de ver qué rompió hoy.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ifUcxR4f9ouDzeWShPMzDA/espera_v2.jpg',
  title: 'Ansiedad extrema',
  description: 'Esa mirada de desesperación cuando ve que tomas tus llaves.'
}];
export function PainGrid() {
  return <section className="py-10 px-5 max-w-6xl mx-auto pt-[20px] pb-[20px]" data-id="element-215">
      <FadeInUp data-id="element-216">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-slate-dark mb-8" data-id="element-217">
          ¿Tu perro vive en un estado de alerta constante?
        </h2>
      </FadeInUp>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-[10px]" data-id="element-218">
        {painPoints.map((point, index) => {
        return <FadeInUp key={index} delay={index * 0.1} data-id="element-219">
              <div className="bg-zen-beige p-8 rounded-3xl h-full flex flex-col items-center text-center pt-[20px] pb-[20px]" data-id="element-220">
                <div className="w-full max-w-[280px] rounded-2xl overflow-hidden border-4 border-white shadow-md mb-6" data-id="element-221">
                  <img src={point.image} alt={point.title} className="w-full h-48 object-cover" width={476} height={192} loading="lazy" decoding="async" data-id="element-222" />
                </div>
                <h3 className="text-xl font-bold text-slate-dark mb-4" data-id="element-223">
                  {point.title}
                </h3>
                <p className="text-slate-dark/70 leading-relaxed" data-id="element-224">
                  {point.description}
                </p>
              </div>
            </FadeInUp>;
      })}
      </div>
    </section>;
}